import { t as globalT } from "@lingui/core/macro";
import { createFileRoute } from "@tanstack/react-router";

import ChooseProject from "@/components/ChooseProject.tsx";

export const Route = createFileRoute("/flows/download/choose-project")({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title:
          globalT`Sweco REALity` +
          " - " +
          globalT`Download` +
          " - " +
          globalT`Choose project`,
      },
    ],
  }),
});

function RouteComponent() {
  return <ChooseProject link="/flows/download/selection/$identifier" />;
}
